import { findEntityAt } from '@sim/core/grid';
import type { SimState } from '@sim/core/state';
import type { GridPos } from '@sim/core/types';

export interface EraseGuardEngine {
  canErase(pos: GridPos): boolean;
  state(): SimState;
}

export interface EraseGuardOnboarding {
  canEraseObservable(): boolean;
}

/** The one authoritative "can this cell be erased right now" check, shared by every erase entry point. */
export function canEraseCell(
  engine: EraseGuardEngine,
  onboarding: EraseGuardOnboarding,
  pos: GridPos,
): boolean {
  if (!engine.canErase(pos)) return false;
  const kind = findEntityAt(engine.state(), pos)?.kind;
  return kind !== 'observable' || onboarding.canEraseObservable();
}
